module.exports = {
    defaultLanguage: 'es',
    scssVariables: './src/styles/adama2023',
    profileColor: {saturation: 80, brightness: 90},
    favicon: 'adamafavicon.ico',
    defaultPassword: 'default'
}